// Auto-generated imports for web dependencies
import "highlightjs-copy";
import "@fortawesome/fontawesome-free/css/fontawesome.css";
import "@fortawesome/fontawesome-free";
import "highlight.js";

// Auto-generated imports for project sources
import "./web/app/css/admonitions.css";
import "./web/app/css/colors.css";
import "./web/app/css/darkmode.css";
import "./web/app/css/main.css";
import "./web/app/css/navigation.css";
import "./web/app/css/tables.css";
export * from "./web/app/js/about";
export * from "./web/app/js/highlightjs-line-numbers";
export * from "./web/app/js/quotes";
export * from "./web/app/main";

